const image = `<img src="<%- src %>" alt="" />`

export const linkTemplate = `
  <a
    href="<%- href %>"
    target="_blank"
    rel="noopener noreferrer"
    data-promo-button
  >
    ${image}
  </a>
`

export const template = `
  <span data-promo-button>
    ${image}
  </span>
`
